import { render } from "./WorkstationForVerificationPreviewModal.vue?vue&type=template&id=cc0e94e2&ts=true"
import script from "./WorkstationForVerificationPreviewModal.vue?vue&type=script&lang=ts"
export * from "./WorkstationForVerificationPreviewModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__